import { useNavigation } from '@helios/frontend-core';
import { useEffect } from 'react';

import { trackPlaidEvent } from '../../pages/BankVerificationPage/plaid-tracking';
import {
  buildInterruptionProperties,
  clearPlaidInFlightMarker,
  isPlaidMarkerRecoverable,
  readPlaidInFlightMarker,
} from '../../utils/plaidInFlightMarker';

const usePlaidSessionRecovery = (): void => {
  const { openURL } = useNavigation();

  useEffect(() => {
    const marker = readPlaidInFlightMarker();
    if (!marker) return;

    if (!isPlaidMarkerRecoverable(marker)) {
      clearPlaidInFlightMarker();
      trackPlaidEvent('linkInterrupted', { ...buildInterruptionProperties(marker), reason: 'expired' });
      return;
    }

    openURL(marker.route);
  }, []);
};

export default usePlaidSessionRecovery;
